
export const environment = {
  production: true,
  apiBaseUrl: '/alisse-frontend/ws',
  pollTime: 2000,
  domain: 'bps.gub.uy'
};